export default "__VITE_ASSET__BRfHaeh9__"